/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360BusinessLogicItemTypesBEItemType {
    ID?: number;
    SingleForm?: string;
    PluralForm?: string;
    MeasurementTypes?: Array<Open360BusinessLogicItemTypesBEItemType.MeasurementTypesEnum>;
}
export namespace Open360BusinessLogicItemTypesBEItemType {
    export type MeasurementTypesEnum = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';
    export const MeasurementTypesEnum = {
        _1: '1' as MeasurementTypesEnum,
        _2: '2' as MeasurementTypesEnum,
        _3: '3' as MeasurementTypesEnum,
        _4: '4' as MeasurementTypesEnum,
        _5: '5' as MeasurementTypesEnum,
        _6: '6' as MeasurementTypesEnum,
        _7: '7' as MeasurementTypesEnum,
        _8: '8' as MeasurementTypesEnum,
        _9: '9' as MeasurementTypesEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicItemTypesBEItemType.ts